export const TAX_YEAR = {
  TAX_YEAR_SET_SELECTED: "TAX_YEAR_SET_SELECTED",
  TAX_YEAR_CLEAR_SELECTED: "TAX_YEAR_CLEAR_SELECTED",
};
